import { Button, ToggleButton } from '@heroui/react'
import { Icon } from '../ui/icons'
import { Glyph } from './Editor'
import { MAX_PAGES, pageLabel, withPages } from './pages'
import type { KioskScreen, LayoutDocument } from './types'
import { useStaffText } from '../ui/StaffText'

/**
 * A kiosk's screens as a list in the left panel: the welcome, each menu page, a way
 * to add one, and the ticket. A page is what a designer is drawing on.
 */
export function PageTabs({
  document: doc,
  screen,
  page,
  onPick,
  onAddPage,
}: {
  document: LayoutDocument
  screen: KioskScreen
  page: string
  onPick: (screen: KioskScreen, page?: string) => void
  onAddPage: () => void
}) {
  // Named in the reader's language; the canvas switch changes the canvas only.
  const { say, lang } = useStaffText()
  const pages = withPages(doc).pages!
  return (
    <div className="studio-screens" role="group" aria-label={say('designs.ed.kioskScreen')}>
      <ToggleButton
        variant="ghost"
        size="sm"
        className="studio-navrow"
        isSelected={screen === 'attract'}
        data-off={doc.canvas.skipWelcome || undefined}
        onPress={() => onPick('attract')}
      >
        <Glyph of="media" size={16} />
        <span className="studio-navrow__name">{say('designs.ed.welcome')}</span>
      </ToggleButton>
      {pages.map((p) => (
        <ToggleButton
          key={p.id}
          variant="ghost"
          size="sm"
          className="studio-navrow"
          isSelected={screen === 'choosing' && page === p.id}
          onPress={() => onPick('choosing', p.id)}
        >
          <Glyph of={p.id === pages[0]!.id ? 'services' : 'page'} size={16} />
          <span className="studio-navrow__name">{pageLabel(doc, p.id, lang)}</span>
        </ToggleButton>
      ))}
      <ToggleButton variant="ghost" size="sm" className="studio-navrow" isSelected={screen === 'issued'} onPress={() => onPick('issued')}>
        <Glyph of="ticketNumber" size={16} />
        <span className="studio-navrow__name">{say('designs.ed.ticket')}</span>
      </ToggleButton>
      <Button variant="ghost" size="sm" className="studio-navrow studio-navrow--add" isDisabled={pages.length >= MAX_PAGES} onPress={onAddPage}>
        <Icon name="plus" size={16} />
        <span className="studio-navrow__name">{say('designs.ed.addPage')}</span>
      </Button>
    </div>
  )
}
